import { atom } from "jotai";
import type { Message, ToolCallData, ToolResult } from "../types";

export type RenderChunk =
  | { type: "content"; text: string }
  | {
      type: "tool_calls";
      calls: ToolCallData[];
      phase: "pending" | "executing" | "complete";
    };

export interface ToolProgressState {
  command: string;
  completed: number;
  failed: number;
  total: number;
  elapsed_s: number;
}

/** How long incoming phrase spans keep fading after the last content token. */
export const STREAM_FADE_MS = 300;

export interface StreamingState {
  streamId: string;
  sessionId?: string;
  isStreaming: boolean;
  /** True while phrase-span fades should keep the streaming turn mounted. */
  fadeHold: boolean;
  lastContentAt?: number;
  aborted?: boolean;
  streamingMessage: Message | null;
  streamingUserMessage: Message | null;
  streamingToolCalls: ToolCallData[];
  toolExecutionPhase: "none" | "executing" | "complete";
  toolProgress: ToolProgressState | null;
  toolResults: Map<string, ToolResult>;
  renderChunks: RenderChunk[];
  userMessageId?: string;
  error?: string;
  abortController: AbortController;
}

export const streamsAtom = atom<Map<string, StreamingState>>(new Map());
